(() => {
  const upgraded = new WeakSet();
  const sourcePattern = /\/([a-f0-9]{32})S(?:_[^/?#.]*)?\.(?:jpe?g|png)(?:[?#]|$)/i;
  const productImageSelector = [
    '[data-main-product-image]',
    '.fsp-product img',
    '.fsp-fitment-product img',
    '.fsp-sale-product img',
    '.fsp-product-related img',
    '.fsp-wishlist-item img',
    '.fsp-cart-line img',
    '.fsp-side-cart__item img'
  ].join(',');

  const originalShopifySource = (source) => {
    try {
      const url = new URL(source, location.origin);
      if (url.hostname !== 'cdn.shopify.com' || !url.pathname.includes('/s/files/')) return '';
      ['width', 'height', 'crop', 'pad_color'].forEach((parameter) => url.searchParams.delete(parameter));
      return url.href;
    } catch (_) {
      return '';
    }
  };

  const upgrade = (image) => {
    if (!(image instanceof HTMLImageElement) || upgraded.has(image)) return;
    const candidates = [image.currentSrc, image.src];
    const srcset = image.getAttribute('srcset') || '';
    srcset.split(',').forEach((candidate) => candidates.push(candidate.trim().split(/\s+/)[0]));
    const match = candidates.filter(Boolean).map((source) => source.match(sourcePattern)).find(Boolean);
    const shopifyOriginal = image.matches(productImageSelector) ? originalShopifySource(image.src) : '';
    if (!match && !shopifyOriginal) return;

    upgraded.add(image);
    const originalSrc = image.src;
    const originalSrcset = image.getAttribute('srcset');
    const originalSizes = image.getAttribute('sizes');
    const largeSource = match
      ? `https://d32vzsop7y1h3k.cloudfront.net/${match[1]}L.JPG`
      : shopifyOriginal;

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.addEventListener('error', () => {
      image.src = originalSrc;
      if (originalSrcset) image.setAttribute('srcset', originalSrcset);
      if (originalSizes) image.setAttribute('sizes', originalSizes);
    }, { once: true });
    image.src = largeSource;
  };

  const scan = (root = document) => {
    if (root instanceof HTMLImageElement) upgrade(root);
    root.querySelectorAll?.('img').forEach(upgrade);
  };

  scan();
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => {
      if (node instanceof Element) scan(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
